<template>
    <div class="my-projects">
        <div class="box-wrap">
            <div class="action-box action-box-lg start">
                <div class="box-content">
                    <div class="box-content-image">
                        <img src="https://torindrivena.com/wp-content/themes/torindriveintl/images/initial-quote.png" alt="Initial Quote">
                    </div>
                    <h3>Initial Quote</h3>
                    <p>For bidding purpose only</p>
                    <router-link to="/sform/construction" class="btn-box" style="background: #FFF;" v-if="user.role != 'Field'">Start</router-link>
                    <router-link to="/projects" class="btn-box" style="background: #00b050;" v-else>View Only</router-link>
                </div>
            </div>
            
            <div class="action-box box-sep">
                <div class="box-content">
                    <img src="https://torindrivena.com/wp-content/themes/torindriveintl/images/arrow-separator.png" alt="">
                </div>
            </div>

            <div class="action-box action-box-lg box-yellow">
                <div class="box-content">
                    <div class="box-content-image">
                        <img src="https://torindrivena.com/wp-content/themes/torindriveintl/images/final-proposal.png" alt="Final Proposal">
                    </div>
                    <h3>Final Proposal</h3>
                    <p>Once you have the job</p>
                    <router-link to="/sform/construction/final" class="btn-box" style="background: #ffc000;" v-if="user.role != 'Field'">Start</router-link>
                    <router-link to="/projects" class="btn-box" style="background: #00b050;" v-else>View Only</router-link>
                </div>
            </div>
        </div>

        <div class="box-wrap">

            <div class="action-box action-box-lg box-green">
                <div class="box-content">
                    <div class="box-content-image">
                        <img src="/project/img/verify.png" alt="Verify">
                    </div>
                    <h3>Verify</h3>
                    <p>Verify your job</p>
                    <router-link to="/projects#FINAL" class="btn-box" style="background: #00b050;" v-if="user.role != 'Field'">Verify</router-link>
                    <router-link to="/projects#FINAL" class="btn-box" style="background: #00b050;" v-else>View Only</router-link>
                </div>
            </div>
            
            <div class="action-box action-box-lg box-sep">
                <div class="box-content">
                    <img src="https://torindrivena.com/wp-content/themes/torindriveintl/images/arrow-separator.png" alt="">
                </div>
            </div>

            <div class="action-box action-box-lg box-green">
                <div class="box-content">
                    <div class="box-content-image">
                        <img src="https://torindrivena.com/wp-content/themes/torindriveintl/images/purchase.png" alt="Purchase">
                    </div>
                    <h3>Purchase</h3>
                    <p>Order your job</p>
                    <router-link to="/projects#VERIFIED" class="btn-box" style="background: #00b050;" v-if="user.role != 'Field'">Purchase</router-link>
                    <router-link to="/projects#VERIFIED" class="btn-box" style="background: #00b050;" v-else>View Only</router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'modernization',
    data() {
        var user = localStorage.getItem('user');
        if ( !user ) this.$router.push('login');

        return {
            user: JSON.parse(user)
        }
    }
  }
</script>
<style lang="scss" scoped>
.box-wrap {
    margin-left: 89px;
    &:first-child {
        margin-top: 32px;
    }
    &:nth-child(2) {
        margin-top: 48px;
    }
}
@media (max-width: 992px) {
    .box-wrap {
        max-width: 570px;
        &:first-child {
            margin: 16px auto;
        }
        &:nth-child(2) {
            margin: 32px auto;
        }
        .action-box {
            &.box-sep {
                width: 80px;
            }
        }
    }
}
@media (max-width: 580px) {
    .action-box {
        height: 160px;
        .box-content {
            h3 {
                font-size: 12px;
            }
            p {
                font-size: 11px;
            }
        }
    }
}
@media (max-width: 530px) {
    .box-wrap {
        display: block;
        .action-box {
            margin: 0 auto;
            &.box-sep {
                height: 4em;
                transform: rotate(90deg);
            }
        }
    }
}
</style>
